<template>
  <div id="detail">
    <div class="top">
      <a href="javascript:;" @click="goBack()"></a>
      <span>{{ title }}</span>
    </div>
    <div class="box infos">
      <!-- A股 -->
      <div id="infoA" v-if="cat == 'd_A'">
        <ul class="row clearfix">
          <li>
            <label>新股名称：</label>
            <p>{{ data.name ? data.name : '--' }}</p>
          </li>
          <li>
            <label>申购日期：</label>
            <p>{{ data.sgrq ? data.sgrq : '--' }}</p>
          </li>
          <li>
            <label>股票代码：</label>
            <p>{{ data.code ? data.code : '--' }}</p>
          </li>
          <li>
            <label>申购代码：</label>
            <p>{{ data.subcode ? data.subcode : '--' }}</p>
          </li>
          <li>
            <label>发行价格：</label>
            <p>{{ data.fxjg ? data.fxjg : '--' }}</p>
          </li>
          <li>
            <label>发行市盈率：</label>
            <p>{{ data.fxsyl ? data.fxsyl : '--' }}</p>
          </li>
          <li>
            <label>申购上限：</label>
            <p>{{ data.ycwssgsx ? data.ycwssgsx : '--' }}万股</p>
          </li>
          <li>
            <label>行业市盈率：</label>
            <p>{{ data.hysyl ? data.hysyl : '--' }}</p>
          </li>
          <li style="width: 100%">
            <label style="width: 115px">顶格申购需配市值：</label>
            <p style="padding-left: 120px">{{ data.ycwssgzj ? data.ycwssgzj : '--' }}万元</p>
          </li>
        </ul>
        <h1><i></i>发行概况</h1>
        <ul>
          <li>
            <label>发行总数：</label>
            <p>{{ data.fxzl ? data.fxzl : '--' }}万股</p>
          </li>
          <li>
            <label>网上发行量：</label>
            <p>{{ data.wsfxsl ? data.wsfxsl : '--' }}万股</p>
          </li>
          <!-- <li><label>所属行业：</label><p>{{data.}}</p></li> -->
          <li>
            <label>业务简介：</label>
            <p>{{ data.mainbusin ? data.mainbusin : '--' }}</p>
          </li>
          <!-- <li><label>上市地点：</label><p>{{data.}}</p></li> -->
        </ul>
      </div>

      <!-- 港股 -->
     <div id="infoHK" v-if="cat == 'd_HK'">
        <ul class="row clearfix">
          <li>
            <label>新股名称：</label>
            <p>{{ data.name ? data.name : '--' }}</p>
          </li>
          <li>
            <label>招股日期：</label>
            <p>{{ data.zgrq ? data.zgrq : '--' }}</p>
          </li>
          <li>
            <label>股票代码：</label>
            <p>{{ data.code ? data.code : '--' }}</p>
          </li>
          <li>
            <label>招股价：</label>
            <p>{{ data.zgj ? data.zgj : '--' }}</p>
          </li>
          <li>
            <label>募集资金：</label>
            <p>{{ data.mjzj ? data.mjzj : '--' }}港元</p>
          </li>
          <li>
            <label>招股数：</label>
            <p>{{ data.zgs ? data.zgs : '--' }}股</p>
          </li>
          <li>
            <label>上市日期：</label>
            <p>{{ data.ssrq ? data.ssrq : '--' }}</p>
          </li>
        </ul>
        
      </div>

      <!-- 新三板 -->
      <div id="infoXSB" v-if="cat == 'd_XSB'">
        <ul class="row clearfix">
          <li>
            <label>新股名称：</label>
            <p>{{ data.name ? data.name : '--' }}</p>
          </li>
          <li>
            <label>申购日期：</label>
            <p>{{ data.sgrq ? data.sgrq : '--' }}</p>
          </li>
          <li>
            <label>股票代码：</label>
            <p>{{ data.code ? data.code : '--' }}</p>
          </li>
          <li>
            <label>申购代码：</label>
            <p>{{ data.subcode ? data.subcode : '--' }}</p>
          </li>
          <li>
            <label>发行价格：</label>
            <p>{{ data.fxjg ? data.fxjg : '--' }}</p>
          </li>
          <li>
            <label>顶格申购<br />所需资金：</label>
            <p>{{ data.dgsgsxzj ? data.dgsgsxzj : '--' }}元</p>
          </li>
          <li>
            <label>申购上限：</label>
            <p>{{ data.sgsx ? data.sgsx : '--' }}股</p>
          </li>
          <li>
            <label>发行市盈率：</label>
            <p>{{ data.fxsyl ? data.fxsyl : '--' }}</p>
          </li>
        </ul>
        <h1><i></i>发行概况</h1>
        <ul>
          <li>
            <label>发行总数：</label>
            <p>{{ data.fxzl ? data.fxzl : '--' }}</p>
          </li>
          <li>
            <label>网上发行量：</label>
            <p>{{ data.wsfxsl ? data.wsfxsl : '--' }}股</p>
          </li>
          <!-- <li>
            <label>发行方式：</label>
            <p>{{ data. ? data. : '--' }}</p>
          </li>
          <li>
            <label>市盈率参考行业：</label>
            <p>{{ data. ? data. : '--' }}</p>
          </li> -->
        </ul>
      </div>

      <!-- 可转债 -->
      <div id="infoKZZ" v-if="cat == 'd_KZZ'">
        <ul class="row clearfix">
          <li>
            <label>新债名称：</label>
            <p>{{ data.name ? data.name : '--' }}</p>
          </li>
          <li>
            <label>新债代码：</label>
            <p>{{ data.code ? data.code : '--' }}</p>
          </li>
          <li>
            <label>正股简称：</label>
            <p>{{ data.zgjc ? data.zgjc : '--' }}</p>
          </li>
          <li>
            <label>正股代码：</label>
            <p>{{ data.zgdm ? data.zgdm : '--' }}</p>
          </li>
          <!-- <li>
            <label>债券评级：</label>
            <p>{{ data. ? data. : '--' }}</p>
          </li>
          <li>
            <label>主体评级：</label>
            <p>{{ data. ? data. : '--' }}</p>
          </li> -->
          <li>
            <label>正股价：</label>
            <p>{{ data.zhenggj ? data.zhenggj : '--' }}</p>
          </li>
          <li>
            <label>转股价：</label>
            <p>{{ data.zhuangj ? data.zhuangj : '--' }}</p>
          </li>
          <li>
            <label>转股溢价率：</label>
            <p>{{ data.zgyjl ? data.zgyjl : '--' }}</p>
          </li>
        </ul>
        <h1><i></i>申购详情</h1>
        <ul>
          <li>
            <label>申购简称：</label>
            <p>{{ data.name ? data.name : '--' }}</p>
          </li>
          <li>
            <label>申购代码：</label>
            <p>{{ data.subcode ? data.subcode : '--' }}</p>
          </li>
          <li>
            <label>申购日期：</label>
            <p>{{ data.sgrq ? data.sgrq : '--' }}</p>
          </li>
          <li>
            <label>申购上限：</label>
            <p>{{ data.sgsx ? data.sgsx : '--' }}万元</p>
          </li>
          
          <li>
            <label>描述：</label>
            <p>{{ data.desc ? data.desc : '--' }}</p>
          </li>
        </ul>
        <!-- <h1><i></i>配售详情</h1> -->
        <ul>
          <!-- <li>
            <label>配售简称：</label>
            <p>{{ data. ? data. : '--' }}</p>
          </li>
          <li>
            <label>配售代码：</label>
            <p>{{ data. ? data. : '--' }}</p>
          </li>
          <li>
            <label>股权登记日：</label>
            <p>{{ data. ? data. : '--' }}</p>
          </li>
          <li></li> -->
        </ul>

      </div>

      <!-- 新基金 -->
      <ul v-if="cat == 'd_XJJ'">
        <li>
          <label>基金简称：</label>
          <p>{{ data.name }}</p>
        </li>
        <li>
          <label>基金代码：</label>
          <p>{{ data.code }}</p>
        </li>
        <li>
          <label>发行公司：</label>
          <p>{{ data.fxgs }}</p>
        </li>
        <li>
          <label>基金类型：</label>
          <p>{{ data.jjlx }}</p>
        </li>
        <li>
          <label>集中认购期：</label>
          <p>{{ data.jzrgq_start }} ~ {{ data.jzrgq_end }}</p>
        </li>
        <li>
          <label style="width: 90px">最高认购费率：</label>
          <p style="padding-left: 95px">{{ data.zgrgfl }}</p>
        </li>
        <li>
          <label>基金经理：</label>
          <p>{{ data.jjjl }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Detail",
  data() {
    return {
      title: "新股详情",
      data: {},
      cat: "",
    };
  },
  mounted() {
    var _this = this;

    // 获取缓存的数据
    // console.log(_this.data)
    _this.data = JSON.parse(localStorage.getItem("detail"));
    _this.cat = localStorage.getItem("cat");
    // console.log(_this.data);
    // console.log(_this.cat);
    if (!_this.data || !_this.cat) {
      // 没有内容，返回首页
      this.$router.push({
        path: "/",
      });
    }
    // 写入页面

    // if (_this.cat === "d_A") {
    //   // A股
    // }

    // if (_this.cat === "d_HK") {
    //   // 港股
    // }

    // if (_this.cat === "d_XSB") {
    //   // 新三板
    // }

    // if (_this.cat === "d_KZZ") {
    //   // 可转债
    // }

    if (_this.cat === "d_XJJ") {
      _this.title = "新基金详情";
    } else {
      _this.title = "新股详情";
    }

    document.title = _this.title;
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/") {
      to.meta.keepAlive = true;
    } else {
      to.meta.keepAlive = false;
    }
    next();
  },
  methods: {
    goBack: function () {
      // console.log("back");
      this.$router.push({
        path: "/",
      });
    },
  },
};
</script>

<style lang="less">
@import url("../assets/common.less");
.top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 40px;
  text-align: center;
  background: #fff;
  border-bottom: 1px solid #eee;
  z-index: 10;
  a {
    display: block;
    position: absolute;
    top: 5px;
    left: 5px;
    width: 30px;
    height: 30px;
    background: url("../assets/icon_back.png") no-repeat center center;
    background-size: 14px auto;
  }
  span {
    font-size: @text;
    color: @black;
    line-height: 40px;
    text-align: center;
  }
}
#detail {
  .box {
    padding: 10px 0
  }
  .infos {
  margin-top: 50px;
  h1 {
    padding: 15px 0 10px 15px;
    font-size: @text;
    i {
      margin-right: 8px;
      height: @text;
    }
  }
  ul {
    padding: 0 15px 30px 5px;
    li {
      position: relative;
      display: block;
      padding: 5px 0;
      label {
        position: absolute;
        top: 6px;
        left: 0;
        display: block;
        width: 80px;
        font-size: @desc;
        color: @gray;
        line-height: 20px;
        text-align: right;
      }
      p {
        padding-left: 85px;
        font-size: @text;
        color: @black;
        line-height: 20px;
      }
    }
  }
  ul.row {
    padding-bottom: 0;
    li {
      float: left;
      width: 50%;
    }
  }
}
}

</style>